import React from 'react';
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function SpecieRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/specie', component: Index, isProtected: true, permissions: ['specie_index']},
    {path: '/specie/create', component: Create, isProtected: true, permissions: ['specie_create']},
    {path: '/specie/edit/:id', component: Edit, isProtected: true, permissions: ['specie_edit']},

  ];

  return routes;
}